// Fade + sink downward on death.

import type { Animation } from "../../engine/animation/AnimationQueue";
import { Easing } from "../../engine/animation/Easing";
import { TIMING } from "../../config/constants";
import type { UnitVisual } from "../UnitVisual";

export class DeathAnim implements Animation {
  private elapsed = 0;
  private duration = TIMING.deathFade;
  onEnd?: () => void;

  constructor(private visual: UnitVisual) {}

  update(dt: number): void {
    this.elapsed = Math.min(this.elapsed + dt, this.duration);
    const p = this.elapsed / this.duration;
    this.visual.alpha = 1 - Easing.easeInQuad(p);
    this.visual.y += dt * 0.07; // ~30px drift down over 420ms
    this.visual.scale = 1 - p * 0.2;
  }

  isDone(): boolean {
    return this.elapsed >= this.duration;
  }
}
